export const guards: Record<string, string> = {
  'Action': 'Action',
  'Active Join Code': 'Code d’adhésion actif',
  'Add a personal message to your invite...':
    'Ajoutez un message personnel à votre invitation...',
  'Add notes for the guard...': 'Ajoutez des notes concernant l’agent...',
  'All Licences': 'Toutes les licences',
  'Authority': 'Autorité',
  'Code': 'Code',
  'Code History': 'Historique des codes',
  'Copy licence number': 'Copier le numéro de licence',
  'Country': 'Pays',
  'Created': 'Créé',
  'Decision': 'Décision',
  'Expired / Deactivated': 'Expiré / désactivé',
  'Expiry': 'Expiration',
  'Expiry Date': 'Date d’expiration',
  'Find Guards': 'Trouver des agents',
  'Guard Notes': 'Notes sur l’agent',
  'Guard Profiles': 'Profils des agents',
  'Invited': 'Invité',
  'Issue Date': 'Date de délivrance',
  'Join Codes': 'Codes d’adhésion',
  'Licence Document': 'Document de licence',
  'Licence document': 'Document de licence',
  'Licence No.': 'N° de licence',
  'Licence Number': 'Numéro de licence',
  'Licence Type': 'Type de licence',
  'Licences': 'Licences',
  'Member Since': 'Membre depuis',
  'No active join code. Generate one to let guards join your company.':
    'Aucun code d’adhésion actif. Générez-en un pour permettre aux agents de rejoindre votre entreprise.',
  'No document attached': 'Aucun document joint',
  'No valid licences found. Showing the most recently expired licence.':
    'Aucune licence valide trouvée. Affichage de la licence expirée la plus récente.',
  'Notes': 'Notes',
  'Pending approval': 'En attente d’approbation',
  'Phone': 'Téléphone',
  'Review Details': 'Détails de l’examen',
  'Review Licence': 'Examiner la licence',
  'Reviewed at': 'Examinée le',
  'Reviewed by': 'Examinée par',
  'Reviewer Notes (optional)': 'Notes de l’examinateur (facultatif)',
  'Search by name...': 'Rechercher par nom...',
  'Send Invite': 'Envoyer l’invitation',
  'Submitted': 'Soumis',
  'This guard currently has no licence or licence request.':
    'Cet agent ne possède actuellement aucune licence ni demande de licence.',
  'Uses': 'Utilisations',
  'View document (PDF)': 'Voir le document (PDF)',
  '(optional)': '(facultatif)',
  'Could not load licence details.': 'Impossible de charger les détails de la licence.',
  'Failed to deactivate code': 'Impossible de désactiver le code',
  'Failed to generate code': 'Impossible de générer le code',
  'Failed to revoke invite': 'Impossible de révoquer l’invitation',
  'Failed to send invite': 'Impossible d’envoyer l’invitation',
  'Invite revoked': 'Invitation révoquée',
  'Invite sent to {name}': 'Invitation envoyée à {name}',
  'Message': 'Message',
  'Unknown error': 'Erreur inconnue',
  'guard': 'l’agent',
  'Joined': 'Inscrit le',
  'Deactivate': 'Désactiver',
  'Reactivate': 'Réactiver',
  'Deactivated': 'Désactivé',
  'Hide deactivated': 'Masquer les désactivés',
  'Show {count} deactivated': 'Afficher {count} désactivés',

  // Staff directory
  'All staff': 'Tout le personnel',
  'Managers': 'Responsables',
  'Admins': 'Administrateurs',
  'Manager': 'Responsable',
  'Admin||role': 'Administrateur',
  'Everyone in your company: admins, managers and guards.':
    'Toutes les personnes de votre entreprise : administrateurs, responsables et agents.',
  'Add user': 'Ajouter un utilisateur',
  'Filter staff by role': 'Filtrer le personnel par rôle',
  'Search by name or email': 'Rechercher par nom ou adresse e-mail',
  'No email': 'Aucune adresse e-mail',
  'No staff yet. Add a user to email them an invite, or share a join code with guards who already have the app.':
    'Aucun membre du personnel pour l’instant. Ajoutez un utilisateur pour lui envoyer une invitation par e-mail, ou partagez un code d’adhésion avec les agents qui ont déjà l’application.',
  'Nobody matches these filters.': 'Personne ne correspond à ces filtres.',
  'Could not load your staff.': 'Impossible de charger votre personnel.',
  'Invite sent': 'Invitation envoyée',
  'Invite sent to {email}. They are on your staff list now and can be rostered straight away.':
    'Invitation envoyée à {email}. Cette personne figure désormais dans votre personnel et peut être planifiée immédiatement.',
  '{email} was added, but the invite email could not be sent. Open their profile and choose Resend invite.':
    '{email} a été ajouté, mais l’e-mail d’invitation n’a pas pu être envoyé. Ouvrez son profil et choisissez Renvoyer l’invitation.',

  // Add user dialog
  'We will email them a link to finish setting up their account. They join your staff list as soon as the invite is sent, so you can roster them before they accept.':
    'Nous lui enverrons par e-mail un lien pour finaliser son compte. Cette personne rejoint votre personnel dès l’envoi de l’invitation : vous pouvez donc la planifier avant qu’elle n’accepte.',
  'First name': 'Prénom',
  'Last name': 'Nom',
  'First name and last name are required': 'Le prénom et le nom sont obligatoires',
  'Sending invite...': 'Envoi de l’invitation...',
  'Roles': 'Rôles',
  'Loading roles...': 'Chargement des rôles...',
  'Could not load roles.': 'Impossible de charger les rôles.',
  'Choose at least one role': 'Choisissez au moins un rôle',
  'They will sign in to this workspace and work shifts from the mobile app.':
    'Cette personne se connectera à cet espace de travail et effectuera ses vacations depuis l’application mobile.',
  'They will sign in to this workspace. They will not be rostered as a guard.':
    'Cette personne se connectera à cet espace de travail. Elle ne sera pas planifiée comme agent.',
  'They will work shifts and use the mobile app. Guards do not sign in to this workspace.':
    'Cette personne effectuera des vacations et utilisera l’application mobile. Les agents ne se connectent pas à cet espace de travail.',

  // Choosing roles (add-user dialog and staff profile)
  'Guard role': 'Rôle d’agent',
  'Management roles': 'Rôles de gestion',
  'Works shifts and uses the mobile app.': 'Effectue des vacations et utilise l’application mobile.',
  'Signs in to this workspace and sees the areas the role opens.':
    'Se connecte à cet espace de travail et voit les sections ouvertes par le rôle.',
  'One at a time: choosing another replaces it.': 'Un seul à la fois : en choisir un autre le remplace.',
  'Default pay {rate} per hour': 'Rémunération par défaut : {rate} par heure',
  'Every area, including billing, pay rates and roles':
    'Toutes les sections, y compris la facturation, les taux de rémunération et les rôles',
  'No workspace areas yet': 'Aucune section de l’espace de travail pour l’instant',
  'System Owner': 'Propriétaire du système',
  'Change roles': 'Modifier les rôles',
  'Roles for {name}': 'Rôles de {name}',
  'Their roles add up: they can open every area any of their roles opens.':
    'Ses rôles se cumulent : cette personne accède à toutes les sections ouvertes par l’un de ses rôles.',
  'Save roles': 'Enregistrer les rôles',
  'Roles updated.': 'Rôles mis à jour.',
  'Could not change their roles.': 'Impossible de modifier ses rôles.',
  'The System Owner is always a system administrator. Transfer ownership first.':
    'Le propriétaire du système est toujours administrateur système. Transférez d’abord la propriété.',
  'You cannot remove your own System Administrator role.':
    'Vous ne pouvez pas retirer votre propre rôle d’administrateur système.',
  'They are the System Owner. Ownership will pass to the longest-serving system administrator, and will not return to them if they are reactivated.':
    'Cette personne est le propriétaire du système. La propriété passera à l’administrateur système le plus ancien et ne lui reviendra pas si son compte est réactivé.',

  // The roles every company starts with, until it renames them. These are
  // reached through a variable (roleDisplayName), so check:i18n cannot see them.
  'Guard Rank 1': 'Agent de rang 1',
  'Guard Rank 2': 'Agent de rang 2',
  'Ops Manager': 'Responsable des opérations',
  'System Administrator': 'Administrateur système',
  'Entry-level guard.': 'Agent débutant.',
  'Senior guard.': 'Agent confirmé.',
  'Runs day-to-day operations from the admin dashboard.':
    'Gère les opérations quotidiennes depuis le tableau de bord d’administration.',
  'Full access to every service and permission.':
    'Accès complet à tous les services et à toutes les autorisations.',

  // Staff profile
  'Staff Profile': 'Profil du membre du personnel',
  'Could not load this profile.': 'Impossible de charger ce profil.',
  'Could not change this account.': 'Impossible de modifier ce compte.',
  'Waiting for them to finish setting up': 'En attente de la finalisation de son compte',
  'Their invite link has expired': 'Son lien d’invitation a expiré',
  'The link expired on {date}. Send a new invite so they can choose a password and sign in.':
    'Le lien a expiré le {date}. Envoyez une nouvelle invitation pour lui permettre de choisir un mot de passe et de se connecter.',
  'Invite emailed on {sent}. The link works until {expires}. They can already be rostered.':
    'Invitation envoyée par e-mail le {sent}. Le lien est valable jusqu’au {expires}. Cette personne peut déjà être planifiée.',
  'The account exists, but the invite email has not been delivered yet. Send it again so they can sign in.':
    'Le compte existe, mais l’e-mail d’invitation n’a pas encore été remis. Renvoyez-le pour lui permettre de se connecter.',
  'A new invite has been sent to {email}. The earlier link no longer works.':
    'Une nouvelle invitation a été envoyée à {email}. Le lien précédent ne fonctionne plus.',
  'Account status': 'Statut du compte',
  'This account is deactivated and cannot sign in. Reactivate it to restore their access.':
    'Ce compte est désactivé et ne peut pas se connecter. Réactivez-le pour rétablir son accès.',
  'Deactivate someone who has left. They will no longer be able to sign in. Their shift history is kept, and you can reactivate them at any time.':
    'Désactivez une personne qui a quitté l’entreprise. Elle ne pourra plus se connecter. L’historique de ses vacations est conservé et vous pouvez la réactiver à tout moment.',
  'Deactivate {name}?': 'Désactiver {name} ?',
  'They will no longer be able to sign in to the app. Shifts they have already worked stay on record, and you can reactivate them at any time.':
    'Cette personne ne pourra plus se connecter à l’application. Les vacations déjà effectuées restent enregistrées et vous pouvez la réactiver à tout moment.',
  'They will no longer be able to sign in to this workspace. You can reactivate them at any time.':
    'Cette personne ne pourra plus se connecter à cet espace de travail. Vous pouvez la réactiver à tout moment.',
  'Deactivating...': 'Désactivation...',
  'Review submitted licences, check them against the issuing authority and keep expiring credentials in view.':
    'Examinez les licences soumises, vérifiez-les auprès de l’autorité de délivrance et gardez un œil sur celles qui arrivent à expiration.',
  'Counts across all licences on file': 'Totaux pour toutes les licences enregistrées',
  'Pending Review': 'En attente d’examen',
  'Approved||licence': 'Approuvée',
  'Rejected||licence': 'Rejetée',
  'Expired||licence': 'Expirée',
  'Revoked||licence': 'Révoquée',
  'Valid||licence': 'Valide',
  'Expiring Soon': 'Expire bientôt',
  'Expiring Soon (30 days)': 'Expire bientôt (30 jours)',
  'All Statuses': 'Tous les statuts',
  'All Types': 'Tous les types',
  'All Authorities': 'Toutes les autorités',
  'Any Expiry': 'Toutes les échéances',
  'Submitted (Newest)': 'Soumission (la plus récente)',
  'Submitted (Oldest)': 'Soumission (la plus ancienne)',
  'Expiry (Soonest)': 'Expiration (la plus proche)',
  'Expiry (Latest)': 'Expiration (la plus lointaine)',
  'Guard (A–Z)': 'Agent (A–Z)',
  'Search guards, licence numbers or types':
    'Rechercher un agent, un numéro ou un type de licence',
  'Showing {first}-{last} of {total} licences':
    'Affichage de {first} à {last} sur {total} licences',
  'No licences pending review': 'Aucune licence en attente d’examen',
  'New submissions from your guards will appear here.':
    'Les nouvelles demandes de vos agents apparaîtront ici.',
  'No licences found': 'Aucune licence trouvée',
  'Adjust the filters or refresh to pull the latest licence data.':
    'Ajustez les filtres ou actualisez pour récupérer les dernières données de licence.',
  'Unable to load licences. Please try again.':
    'Impossible de charger les licences. Veuillez réessayer.',
  'Copied': 'Copié',
  'Check on {portal}': 'Vérifier sur {portal}',
  'PSA Portal': 'Portail PSA',
  'SIA Portal': 'Portail SIA',
  'Authority Portal': 'Portail de l’autorité',
  'Copies the licence number to your clipboard and opens the PSA register — paste it into the "Licence No." field to search.':
    'Copie le numéro de licence dans le presse-papiers et ouvre le registre de la PSA — collez-le dans le champ « Licence No. » pour lancer la recherche.',
  'Opens the {authority} licence register in a new tab. Copy the licence number above to search.':
    'Ouvre le registre des licences {authority} dans un nouvel onglet. Copiez le numéro de licence ci-dessus pour lancer la recherche.',
  'Choose a band': 'Choisir une tranche',
  'Choose their contract hours': 'Choisissez ses heures contractuelles',
  'Contract hours': 'Heures contractuelles',
  'Contract hours for {name}': 'Heures contractuelles de {name}',
  'Contract hours saved.': 'Heures contractuelles enregistrées.',
  'Could not save their contract hours.': 'Impossible d’enregistrer ses heures contractuelles.',
  'Invite sent to {email}, but their contract hours could not be saved. Set them from their profile.': 'Invitation envoyée à {email}, mais ses heures contractuelles n’ont pas pu être enregistrées. Renseignez-les depuis son profil.',
  'Missing details': 'Informations manquantes',
  'Missing profile details': 'Informations de profil manquantes',
  'No contract hours': 'Aucune heure contractuelle',
  'Irish ERO: 24-hour contract required': 'ERO irlandais : contrat de 24 heures requis',
  'ERO minimum-hours exception': 'Dérogation ERO aux heures minimales',
  'ERO exception': 'Dérogation ERO',
  'Choose an exception': 'Choisir une dérogation',
  'Demonstrably fewer operational hours': 'Heures opérationnelles manifestement inférieures',
  'Subsisting employer/worker arrangement': 'Accord existant entre employeur et salarié',
  'Exception evidence note': 'Note justificative de la dérogation',
  'Record the operational evidence or the date and parties to the subsisting arrangement.':
    'Consignez les éléments opérationnels ou la date et les parties à l’accord existant.',
  'Choose the documented ERO exception for a contract below 24 hours.':
    'Choisissez la dérogation ERO documentée pour un contrat inférieur à 24 heures.',
  'Add a clear note showing why the ERO exception applies.':
    'Ajoutez une note claire indiquant pourquoi la dérogation ERO s’applique.',
  'After six months, an Irish security operative must normally be guaranteed at least 24 hours per week. A lower band requires a documented ERO exception.':
    'Après six mois, un agent de sécurité irlandais doit normalement bénéficier d’au moins 24 heures garanties par semaine. Une tranche inférieure nécessite une dérogation ERO documentée.',
  '{count} Irish guard has completed six months of service without a contract guaranteeing at least 24 hours per week.':
    '{count} agent irlandais a accompli six mois de service sans contrat garantissant au moins 24 heures par semaine.',
  '{count} Irish guards have completed six months of service without contracts guaranteeing at least 24 hours per week.':
    '{count} agents irlandais ont accompli six mois de service sans contrat garantissant au moins 24 heures par semaine.',
  'No guaranteed hours': 'Aucune heure garantie',
  'Save contract hours': 'Enregistrer les heures contractuelles',
  'Set contract hours': 'Renseigner les heures contractuelles',
  'Show everyone': 'Afficher tout le monde',
  'Show them': 'Les afficher',
  'The weekly hours they are guaranteed. Auto scheduling gives guards at least the bottom of their band where the rules allow.': 'Les heures hebdomadaires qui lui sont garanties. La planification automatique donne aux agents au moins le bas de leur tranche lorsque les règles le permettent.',
  'Their contract hours are not set. Guards who join with a join code start without them, and auto scheduling cannot give them their contracted hours until they are.': 'Ses heures contractuelles ne sont pas renseignées. Les agents qui rejoignent l’entreprise avec un code d’adhésion n’en ont pas au départ, et la planification automatique ne peut pas leur donner leurs heures contractuelles tant qu’elles ne le sont pas.',
  '{count} guard has no contract hours on file. Auto scheduling cannot give them their hours until you set them.': '{count} agent n’a pas d’heures contractuelles enregistrées. La planification automatique ne peut pas lui donner ses heures tant que vous ne les avez pas renseignées.',
  '{count} guards have no contract hours on file. Auto scheduling cannot give them their hours until you set them.': '{count} agents n’ont pas d’heures contractuelles enregistrées. La planification automatique ne peut pas leur donner leurs heures tant que vous ne les avez pas renseignées.',
  '{min}-{max} hours a week': '{min} à {max} heures par semaine',

  // Staff profile: correcting details, and the clients and sites a guard is bound to
  'Edit details': 'Modifier les coordonnées',
  'Details for {name}': 'Coordonnées de {name}',
  'Correct their name or their phone number. The email they sign in with is changed with Reset email.':
    'Corrigez son nom ou son numéro de téléphone. L’adresse e-mail de connexion se modifie avec « Réinitialiser l’e-mail ».',
  'Include the country code. Only the digits are kept.': 'Indiquez l’indicatif du pays. Seuls les chiffres sont conservés.',
  'A guard needs a phone number so they can be reached on shift':
    'Un agent doit avoir un numéro de téléphone pour être joignable pendant sa vacation',
  'Save details': 'Enregistrer les coordonnées',
  'Details saved.': 'Coordonnées enregistrées.',
  'Could not save their details.': 'Impossible d’enregistrer ses coordonnées.',

  // Staff profile: asking for a sign-in email to be reset
  'Reset email': 'Réinitialiser l’e-mail',
  'Reset email for {name}': 'Réinitialiser l’e-mail de {name}',
  'A link is sent to the new address. Their sign-in does not change until they open it and confirm with their current password.':
    'Un lien est envoyé à la nouvelle adresse. Sa connexion ne change pas tant que cette personne ne l’a pas ouvert et confirmé avec son mot de passe actuel.',
  'A link is sent to the new address. They have not set up yet, so opening it takes them on to choose a password, and the invite already sent stops working.':
    'Un lien est envoyé à la nouvelle adresse. Le compte n’étant pas encore configuré, l’ouvrir permet de choisir un mot de passe, et l’invitation déjà envoyée cesse de fonctionner.',
  'New email': 'Nouvelle adresse e-mail',
  'They sign in with {email} today.': 'La connexion se fait aujourd’hui avec {email}.',
  'Sending...': 'Envoi...',
  'That is already the email they sign in with': 'C’est déjà l’adresse e-mail utilisée pour se connecter',
  'A reset link has been sent to {email}. Their sign-in does not change until they confirm it.':
    'Un lien de réinitialisation a été envoyé à {email}. Sa connexion ne change pas tant que cette personne ne l’a pas confirmé.',
  'A link has been sent to {email}. Opening it takes them on to finish setting up.':
    'Un lien a été envoyé à {email}. L’ouvrir permet de terminer la configuration du compte.',
  'Could not send the reset link.': 'Impossible d’envoyer le lien de réinitialisation.',
  'Email reset cancelled. Its link no longer works.': 'Réinitialisation de l’e-mail annulée. Son lien ne fonctionne plus.',
  'Could not cancel the reset.': 'Impossible d’annuler la réinitialisation.',
  'Waiting for them to confirm a new email': 'En attente de la confirmation d’une nouvelle adresse e-mail',
  'Their email reset link no longer works': 'Son lien de réinitialisation de l’e-mail ne fonctionne plus',
  'The link sent to {email} has expired or was locked. They still sign in with {current}. Send it again, or cancel the reset.':
    'Le lien envoyé à {email} a expiré ou a été verrouillé. La connexion se fait toujours avec {current}. Renvoyez-le ou annulez la réinitialisation.',
  'The link for {email} could not be delivered. They still sign in with {current}. Send it again.':
    'Le lien destiné à {email} n’a pas pu être remis. La connexion se fait toujours avec {current}. Renvoyez-le.',
  'A link was emailed to {email} on {sent}. Opening it takes them on to finish setting up. The invite sent to {current} no longer works.':
    'Un lien a été envoyé à {email} le {sent}. L’ouvrir permet de terminer la configuration du compte. L’invitation envoyée à {current} ne fonctionne plus.',
  'A link was emailed to {email} on {sent}. They keep signing in with {current} until they open it and confirm with their password.':
    'Un lien a été envoyé à {email} le {sent}. La connexion se fait toujours avec {current} tant que cette personne ne l’a pas ouvert et confirmé avec son mot de passe.',
  'Send again': 'Renvoyer',
  'Cancel reset': 'Annuler la réinitialisation',

  'Works at': 'Lieux de travail',
  'Recommended: choose the clients or sites they work, so auto scheduling keeps them there.':
    'Recommandé : choisissez les clients ou les sites où cet agent travaille, afin que la planification automatique l’y maintienne.',
  'Choose sites': 'Choisir les sites',
  '{client}: all sites': '{client} : tous les sites',
  '{name} (archived)': '{name} (archivé)',
  'Where {name} works': 'Où travaille {name}',
  'A guard can be rostered at every site unless you limit them here. Auto scheduling only gives a limited guard shifts at the clients and sites you choose.':
    'Un agent peut être planifié sur tous les sites, sauf si vous le limitez ici. La planification automatique ne donne à un agent limité que des vacations chez les clients et sur les sites que vous choisissez.',
  'Sites they can be rostered at': 'Sites où cet agent peut être planifié',
  'Can be rostered anywhere, including at sites added later.': 'Peut être planifié partout, y compris sur les sites ajoutés plus tard.',
  'Chosen clients and sites only': 'Uniquement les clients et sites choisis',
  'Only given shifts at the places you tick below.': 'Ne reçoit des vacations que sur les lieux cochés ci-dessous.',
  'Every site of this client, including ones added later': 'Tous les sites de ce client, y compris ceux ajoutés plus tard',
  'There are no clients or sites to choose yet.': 'Il n’y a encore aucun client ni site à choisir.',
  'Loading clients and sites...': 'Chargement des clients et des sites...',
  'Could not load clients and sites.': 'Impossible de charger les clients et les sites.',
  'Shifts they already hold anywhere else stay on the roster until you take them off.':
    'Les vacations déjà attribuées ailleurs restent au planning tant que vous ne les retirez pas.',
  'Choose at least one client or site, or leave them available to all sites.':
    'Choisissez au moins un client ou un site, ou laissez l’agent disponible pour tous les sites.',
  'Save sites': 'Enregistrer les sites',
  'Sites saved. Auto scheduling will only give them shifts there.':
    'Sites enregistrés. La planification automatique ne lui donnera des vacations que sur ces lieux.',
  'Sites saved. They can be rostered at every site.': 'Sites enregistrés. Cet agent peut être planifié sur tous les sites.',
  'Could not save where they work.': 'Impossible d’enregistrer ses lieux de travail.',
};
